import React from "react";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaEnvelope, FaWhatsapp, FaCalculator, FaMosque, FaBuilding } from "react-icons/fa";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  return (
    <footer
      className={`relative w-full text-white ${className || ""}`}
      style={{
        background: "linear-gradient(135deg, #1fa2b8 0%, #1c8fa3 100%)",
      }}>
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* ================= LEFT BRAND ================= */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
                <img src="/images/logo_patungan.png" alt="" className="p-2" />
              </div>

              <h3 className="text-xl font-bold">Patungan.id</h3>
            </div>

            <p className="text-white/80 text-sm leading-relaxed mb-6">Platform penggalangan dana Zakat, Infak, Sedekah, dan Wakaf (ZISWAF) terpercaya untuk kebaikan bersama.</p>

            {/* SOCIAL */}
            <div className="flex gap-3">
              {[FaFacebookF, FaInstagram, FaTwitter, FaYoutube].map((Icon, i) => (
                <div key={i} className="w-10 h-10 rounded-full bg-white/15 hover:bg-white/25 transition flex items-center justify-center cursor-pointer">
                  <Icon />
                </div>
              ))}
            </div>
          </div>

          {/* ================= LAYANAN ================= */}
          <div>
            <h4 className="font-semibold text-lg mb-5 flex items-center gap-2">
              <span className="w-1.5 h-6 bg-lime-400 rounded-full" />
              Layanan Kami
            </h4>

            <ul className="space-y-4 text-white/90">
              <li className="flex items-center gap-3">
                <FaCalculator className="text-white/80" />
                Kalkulator Zakat
              </li>
              <li className="flex items-center gap-3">
                <FaMosque className="text-white/80" />
                Qurban Online
              </li>
              <li className="flex items-center gap-3">
                <FaBuilding className="text-white/80" />
                Wakaf Online
              </li>
            </ul>
          </div>

          {/* ================= HUBUNGI ================= */}
          <div>
            <h4 className="font-semibold text-lg mb-5 flex items-center gap-2">
              <span className="w-1.5 h-6 bg-lime-400 rounded-full" />
              Hubungi Kami
            </h4>

            <div className="space-y-4">
              <div className="flex items-center gap-3 bg-white/10 rounded-xl px-4 py-3">
                <FaEnvelope className="text-lime-300" />
                <span className="text-sm">admin@patunganindonesia.com</span>
              </div>

              <div className="flex items-center gap-3 bg-white/10 rounded-xl px-4 py-3">
                <FaWhatsapp className="text-lime-300" />
                <span className="text-sm">+62 856-5555-6864</span>
              </div>
            </div>
          </div>

          {/* ================= NEWSLETTER ================= */}
          <div>
            <h4 className="font-semibold text-lg mb-5 flex items-center gap-2">
              <span className="w-1.5 h-6 bg-lime-400 rounded-full" />
              Newsletter
            </h4>

            <p className="text-white/80 text-sm mb-4">Dapatkan kabar kebaikan terbaru.</p>

            <div className="flex bg-white rounded-xl overflow-hidden">
              <input type="email" placeholder="Email Anda..." className="flex-1 px-4 py-3 text-gray-700 outline-none" />
              <button className="bg-lime-500 hover:bg-lime-600 px-4 flex items-center justify-center">➤</button>
            </div>
          </div>
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="border-t border-white/20 text-center py-4 text-sm text-white/80">Copyright © 2026 Patungan.id. All Rights Reserved</div>
    </footer>
  );
};

export default Footer;
